import * as React from "react";
const SvgFiRrVacuum = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-vacuum_svg__a)">
      <path
        fill="#062147"
        d="M23 16a1 1 0 0 0 1-1v-1.375c0-3.092-2.131-5.688-5-6.415V6.125A6.13 6.13 0 0 0 12.875 0a6.1 6.1 0 0 0-6.05 5.163L4.146 22H1a1 1 0 1 0 0 2h3.146c.989 0 1.819-.709 1.975-1.686L8.8 5.477a4.11 4.11 0 0 1 4.075-3.478A4.13 4.13 0 0 1 17 6.124v.875h-1c-1.654 0-3 1.346-3 3v11c0 1.654 1.346 3 3 3h4.5c1.93 0 3.5-1.57 3.5-3.5s-1.57-3.5-3.5-3.5-3.5 1.57-3.5 3.5c0 .539.133 1.044.351 1.5H16a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1h1.375A4.63 4.63 0 0 1 22 13.624v1.375a1 1 0 0 0 1 1zm-4 4.5c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5-.673 1.5-1.5 1.5-1.5-.673-1.5-1.5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-vacuum_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrVacuum;
